module.exports = __webpack_public_path__ + "static/img/pagi.6e73ace.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos-30/pagi.png
// module id = aeL4
// module chunks = 6